class ScrollingTextAnimation {
  constructor() {
    this.init();
  }

  init() {
    this.sections = document.querySelectorAll('.text-with-scroll-section-wrapper');
    if (this.sections.length === 0) return;

    this.setupIntersectionObserver();
    this.setupScrollListener();
  }

  setupIntersectionObserver() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.startAnimation(entry.target);
        } else {
          this.stopAnimation(entry.target);
        }
      });
    }, observerOptions);

    this.sections.forEach(section => {
      this.observer.observe(section);
    });
  }

  setupScrollListener() {
    this.throttledScroll = this.throttle(this.handleScroll.bind(this), 16);
    window.addEventListener('scroll', this.throttledScroll);
  }

  startAnimation(section) {
    section.classList.add('animation-active');
    this.handleScroll();
  }

  stopAnimation(section) {
    section.classList.remove('animation-active');
  }

  handleScroll() {
    const activeSections = document.querySelectorAll('.text-with-scroll-section-wrapper.animation-active');
    
    activeSections.forEach(section => {
      this.animateBlocks(section);
    });
  }

  animateBlocks(section) {
    const blocks = section.querySelectorAll('.text-with-scroll-block');
    if (blocks.length === 0) return;

    const stickyTop = 128; // The top value from CSS
    
    blocks.forEach((block, index) => {
      const blockRect = block.getBoundingClientRect();
      const blockTop = blockRect.top;
      const blockHeight = blockRect.height;
      
      // Check if there's a next block
      if (index < blocks.length - 1) {
        const nextBlock = blocks[index + 1];
        const nextBlockRect = nextBlock.getBoundingClientRect();
        const nextBlockTop = nextBlockRect.top;
        
        // Calculate when the next block starts overlapping with the current sticky block
        const overlapThreshold = stickyTop + blockHeight;
        
        if (blockTop <= stickyTop && nextBlockTop <= overlapThreshold) {
          // Current block is sticky and next block is starting to overlap
          const overlapDistance = overlapThreshold - nextBlockTop;
          const maxOverlap = blockHeight * 0.8; // Allow 80% overlap before fully fading
          const fadeProgress = Math.min(1, overlapDistance / maxOverlap);
          
          // Smooth fade transition
          const opacity = Math.max(0, 1 - fadeProgress);
          
          block.style.opacity = opacity.toFixed(2);
          block.setAttribute('data-block-opacity', opacity.toFixed(2));
          
          if (opacity < 1) {
            block.classList.add('fading');
          } else {
            block.classList.remove('fading');
          }
        } else {
          // No overlap happening, maintain full opacity
          block.style.opacity = '1';
          block.setAttribute('data-block-opacity', '1');
          block.classList.remove('fading');
        }
      } else {
        // Last block, always maintain full opacity
        block.style.opacity = '1';
        block.setAttribute('data-block-opacity', '1');
        block.classList.remove('fading');
      }
    });
  }

  // Throttle function to limit scroll event frequency
  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }

  // Cleanup method
  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    window.removeEventListener('scroll', this.throttledScroll);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ScrollingTextAnimation();
});

// Re-initialize on theme editor changes (for Shopify theme development)
document.addEventListener('shopify:section:load', () => {
  new ScrollingTextAnimation();
}); 